import { Text } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';

const StyledErrorPage = styled.div`
	display: grid;
	place-items: center;
	margin: 100px 0;
	gap: 2em;
	text-align: left;
`;

const StyledErrorText = styled.div`
	padding: 0 1em;
	width: 32em;
	max-width: 100vw;
`;

export const ERROR_MESSAGES = {
	english: {
		title: 'Site currently not available',
		description: 'Our site is currently offline due to maintenance activities.',
		action: 'Please, check this site again later.',
	},
	french: {
		title: 'Site actuellement indisponible',
		description: "Notre site est actuellement hors ligne en raison d'activités de maintenance.",
		action: 'Veuillez consulter à nouveau ce site plus tard.',
	},
	german: {
		title: 'Seite vorübergehend nicht erreichbar',
		description: 'Aufgrund von Wartungsarbeiten ist diese Seite leider vorübergehend nicht erreichbar.',
		action: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
	},
} as const;

const ErrorPage = () => {
	return (
		<StyledErrorPage>
			<StyledErrorText>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.english.title}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.english.description}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.english.action}
				</Text>
			</StyledErrorText>
			<StyledErrorText>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.french.title}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.french.description}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.french.action}
				</Text>
			</StyledErrorText>
			<StyledErrorText>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.german.title}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.german.description}
				</Text>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					{ERROR_MESSAGES.german.action}
				</Text>
			</StyledErrorText>
			<StyledErrorText>
				<Text
					variant={{
						type: 'copy',
						order: '2',
						style: 'normal',
					}}>
					©{new Date().getFullYear()} AUDI AG. All rights reserved.
				</Text>
			</StyledErrorText>
		</StyledErrorPage>
	);
};

export default ErrorPage;
